import { useState } from 'react'
import { type ApolloError, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { useUser } from '../context/User'
import { getBillingPageUrl } from '../utils/urls'

export const CREATE_CUSTOMER_PORTAL_SESSION = gql`
  mutation createCustomerPortalSession(
    $organizationId: OrganizationId!
    $returnURL: String!
  ) {
    createCustomerPortalSession(
      input: { organizationId: $organizationId, returnURL: $returnURL }
    ) {
      ... on CreateCustomerPortalSessionResponse {
        customerPortalSessionUrl
      }
      ... on BillingError {
        userFriendlyMessage
      }
    }
  }
`
export type UseGetPortalSessionResponse = {
  openBillingPortal: (ctaClicked: boolean) => void
  mutationError: ApolloError | undefined
  errorMessage: string | null
  loading: boolean
}

export default function (): UseGetPortalSessionResponse {
  const account = useUser()
  const returnUrl = getBillingPageUrl(null)
  const openBillingPortal = (ctaClicked: boolean): void => {
    if (!ctaClicked) {
      return
    }
    getCustomerPortalSession({
      variables: {
        organizationId: account.currentOrganization?.id,
        returnURL: `${returnUrl}`,
      },
    })
  }
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [getCustomerPortalSession, { error: mutationError, loading }] =
    useMutation(CREATE_CUSTOMER_PORTAL_SESSION, {
      onCompleted(data) {
        if (data?.createCustomerPortalSession.userFriendlyMessage) {
          setErrorMessage(data?.createCustomerPortalSession.userFriendlyMessage)
        } else {
          window.open(
            `${data.createCustomerPortalSession.customerPortalSessionUrl}/customer/update`,
            '_self',
          )
          setErrorMessage(null)
        }
      },
      onError(e) {
        setErrorMessage(
          `Whoops! Looks like there was a problem processing your request. Please try again. If you continue experiencing this problem, please contact us.`,
        )
        console.error(
          `There was a problem fetching the customer portal session: ${e.message}.`,
        )
      },
    })

  return {
    openBillingPortal,
    mutationError,
    errorMessage,
    loading,
  }
}
